import { render } from "./Design.vue?vue&type=template&id=99bd3e66"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "99bd3e66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99bd3e66', script)) {
    api.reload('99bd3e66', script)
  }
  
  module.hot.accept("./Design.vue?vue&type=template&id=99bd3e66", () => {
    api.rerender('99bd3e66', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/Design.vue"

export default script